<template>
	<div class="template_box">
		<div class="content_box">
			
			<el-form ref="form_data" :model="detail_data" :rules="rules" label-width="0px" label-position="left" class="form_data">
				<div class="order_box margin_top">
					<div class="title_text">1、填写订单<span class="red">*</span></div>
						<div class="form-top">
							<el-form-item label="" label-width="0px" prop="order_no">
								<el-input v-model.trim="detail_data.order_no" type="text" :disabled="editable" :maxlength="20" placeholder="实例订单号: 123-1234-12345" @blur="Lost_Focus_blur('order_no')"/>
							</el-form-item>
					  </div>
				</div>
				
				<div class="order_box margin_top">
					<div class="title_text">2、选择购买日期<span class="red">*</span></div>
					<div class="form-top">
						<el-form-item label="" label-width="0px" prop="buy_date">
							<Timing v-model="detail_data.buy_date" @save_time='save_time' :editable_type="editable"></Timing>
						</el-form-item>
					</div>
				</div>
				
				<div class="order_box margin_top">
					<div class="title_text">3、请提供订单截图或购买发票 <span class="red">*</span></div>
					<div class="caption">（最多3张图片，20M以内）</div>
					<div class="form-top">
						<!-- <el-form-item label="" label-width="0px" prop="img_url" v-if="!editable">
						  <Uploader v-model="detail_data.img_url" :upload_type="typeImg" :imgList="order_img" @remove_img_url='remove_img_url' @save_img_url='save_img_url'></Uploader>
						</el-form-item> -->
						<!-- 上传图片 -->
						<el-form-item label="" label-width="0px" prop="pics" v-if="!editable">
						  <UploadImage v-model="detail_data.pics" :upload_type="typeImg" :bg_color="bg_color" style="margin-right: 7px;" :imgList="order_img" @remove_img_url='remove_img_url' @save_img_url='save_img_url'/>
						</el-form-item>
						<!-- 查看图片 -->
						<el-image
						  v-else
						  v-for="(item, index) in this.order_img"
						  :key="index"
						  style="width: 87px; height: 87px;border: 1px #999999 solid;margin: 3px; border-radius: 6px;"
						  fit="contain"
						  :src="item.url"
						  lazy
						  :preview-src-list="[item.url]">
						</el-image>
					</div>
				</div>
				
				<div class="order_box margin_top">
					<div class="title_text">4、请提供手机号<span class="red">*</span></div>
					<div class="form-top">
						<el-form-item label="" label-width="0px" prop="phone">
							<el-input v-model.trim="detail_data.phone" type="text" :disabled="editable" :maxlength="11" placeholder="" @blur="Lost_Focus_blur('phone')"/>
						</el-form-item>
					</div>
				</div>
			</el-form>
			
			<div class="btn_box" :class="editable ? 'btn_EEE' : 'btn_000'">
				<div class="err_class"><span v-if="err_text">{{ err_text }}</span></div>
				<el-button type="primary" :loading="isLoading" @click="fn_save">{{ editable ? '已提交' : '提交' }}</el-button>
			</div>
		</div>
		
	</div>
</template>

<script>
import { postwarrantycard, getvxuserinfo } from "../../plugins/api.js"	
import UploadImage from "../../components/ProductImage.vue"
import Uploader from "../../components/Uploader.vue"
import Timing from "../../components/timing.vue"
import { rules } from './js/formRules.js';
import { Area } from 'vant';

export default {
	name: 'addCard',
	components: { UploadImage, Uploader, Timing, 'van-area': Area,},
   data() {
		return {
			vx_open_id:'',
			err_text:'',
			isLoading: false,
			
			bg_color: "#ffffff",
			typeImg: "img_url",
			order_img: [],
			editable:false,
			flag_base:true,
			
			rules: rules,
			
			detail_data:{
				order_no:'',
				buy_date: '',
				pics: [],
				phone: '',
			},
			
		}
   },
	
   mounted(){
		this.vx_open_id = localStorage.getItem("vx_open_id") ? localStorage.getItem("vx_open_id") : '';
		console.log(this.vx_open_id)
		if(this.vx_open_id){
			// console.log(this.vx_open_id)
		}else{
			// 获取URL中的code参数
			const code = new URLSearchParams(window.location.search).get('code');
			if (code) {
			  // 获取到code，调用接口获取vx_open_id
			  this.get_vxuserinfo(code);
			}else{
				this.$root.$emit('authorize', { url: 'addCard' }); // 获取授权信息
			}
		}
   },
	
	methods: {
		//从后端获取vx_open_id
		async get_vxuserinfo(code){
			const fd = new window.FormData()
			fd.append("code", code)//微信用户vx_open_id
			await getvxuserinfo( fd ).then((res) => {
				console.log(res)
				if(res.code == 0){
					this.vx_open_id = res.data.vx_open_id;
					localStorage.setItem('vx_open_id', this.vx_open_id)
				}
			}, (err) => {
			  console.log(err)
			})
		},
		
		// 汇集各模块判断是否完成事件
		Lost_Focus_blur(name){
			this.post_validateField(name)
		},
		
		// 验证指定元素事件
		post_validateField(name){
			let validate;
			this.$refs.form_data.validateField(name, (val) => {
			  if (!val) {
					validate = true
			      return true;
			    } else {
					validate = false
			      return false;
			    }
			})
			return validate
		},
		
		//正则验证
		validate() {
		  this.$refs.form_data.validate((valid) => {
		    if (valid) {
		      this.flag_base = true
		      return true
		    } else {
		      this.flag_base = false
		      return false
		    }
		  })
		},
		
		//提交
		fn_save() {
			if(this.editable){ return }
			this.err_text = ''
			this.isLoading = true;
			this.validate()
			if(!this.flag_base){ 
				this.isLoading = false;
				return 
			}
			var obj = this.detail_data
			const fd = new window.FormData()
			
			fd.append("vx_open_id", localStorage.getItem('vx_open_id'))//微信用户vx_open_id
			fd.append("order_no", obj.order_no)//订单号
			fd.append("buy_date", obj.buy_date)//购买日期
			fd.append("phone", obj.phone)//手机号码
			
			obj.pics.forEach((item, i) => {
			  fd.append(`pics[${i}]`, item)//图集
			})
			
			postwarrantycard( fd ).then((res) => {
				console.log(res)
				this.isLoading = false;
				if(res.code == 0){
					this.err_text = ''
					setTimeout(()=>{
						this.$router.back() //：后退 ；
					},3000)
					this.editable = true
					this.$root.$emit('showMessage', { messageType: 'success', messageTime: 3000, globalMessage: '提交成功' }); // 触发事件并传递消息
					
				}else{
					this.err_text = res.message
					this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: res.message });
				}
			}, (err) => {
				this.isLoading = false;
				if(err.code == 4010){
					this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: '提交失败<br>请勿重复提交' });
				}else{
					this.err_text = err.message
					this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: err.message });
				}
				console.log(err)
			})
		},
		
		// 选择时间
		save_time(data) {
			this.detail_data.buy_date = data
			this.Lost_Focus_blur('buy_date')
		},
		// 新建保存的活动图
		save_img_url(data) {
			this.detail_data.pics = data
			this.Lost_Focus_blur('pics')
		},
		
		// 新建删除的活动图
		remove_img_url(data) {
		  this.detail_data.pics = data
		  this.Lost_Focus_blur('pics')
		},
		
   }
}
</script>
<style>
.el-cascader-menu {
	min-width: 120px !important;
	box-sizing: border-box;
	color: #606266;
	border-right: solid 1px #E4E7ED;
}
.custom-select .el-select-dropdown {
  z-index: -999 !important;
}
.class_select > .el-select-dropdown{
	display: none !important;
}

</style>
<style lang='less'>
.class_select{
	width: 100%;
	.select_DCDFE6{
		border: 1px solid #DCDFE6;
	}
	.select_red{
		border: 1px solid #F56C6C;
	}
	.select{
		width: 100%;
		display: flex;
		justify-content: space-between;
		
		box-sizing: border-box;
		height: 40px;
		padding: 0 8px;
		font-size: 14px;
		color: #666666;
		background-color: #000;
		border-radius: 4px;
		
		.el-icon-arrow-up:before {
		   content: "\e6e1";
			color: #C0C4CC;
			font-size: 14px;
		}
		.el-input__suffix-inner{
			display: block;
			transition: transform .3s;
			.el-input__icon {
			   height: 100%;
			   width: 15px;
			}
		}
		.suffix_{
			position: absolute;
			right: 0;
			margin-right: 8px;
		}
		.suffix_select{
			transform: rotateZ(0deg) !important;
		}
		.suffix_no{
			transform: rotateZ(180deg) !important;
		}
	}
}

.form_data{
	margin-top: 20px;
}

</style>
<style lang='less' scoped>
.content_box{
	padding-bottom: 40px;
	background: #F7F7F7;
}
.title_text{
	font-size: 14px;
	line-height: 16px;
	text-align: left;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #000000;
}
.caption{
	font-size: 12px;
	font-family: PingFang SC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 14px;
	margin-top: 8px;
	text-align: left;
}
.red{
	color: red;
}

.margin_top{
	margin-top: 40px;
	&:nth-child(1){
		margin-top: 20px;
	}
}

.form-top{
	margin-top: 15px;
	text-align: left;
}

::v-deep .el-form-item__label{
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #000000;
}
::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
	 display: none;
}
::v-deep .el-input__inner::placeholder{
	color: #999999;
}
::v-deep .el-input__inner{
	height: 40px;
	padding: 0 8px;
	font-size: 14px;
	color: #000000;
	background-color: #ffffff;
}
::v-deep .el-textarea__inner{
	padding: 0 8px;
	font-size: 14px;
	color: #000000;
	background-color: #FFFFFF;
}
::v-deep .el-textarea.is-disabled .el-textarea__inner,
::v-deep .el-input.is-disabled .el-input__inner {
   background-color: #FFFFFF;
   border-color: #FFFFFF;
   color: #000000;
   cursor: not-allowed;
}

@media only screen and (max-width: 550px){
  ::v-deep .el-select {
      width: 100%;
  }
}
@media only screen and (min-width: 550px){
	.Provincial{
		width: 100%;
		display: flex;
		.el-form-item{
			flex: 1;
			margin-right: 10px;
			&:last-child{
				margin-right: 0px;
			}
		}
	}
	
	::v-deep .el-select {
      width: 100%;
	}
}
.btn_box{
	padding: 50px 0px 50px 0px;
	.err_class{
		color: red;
		margin-bottom: 10px;
		font-size: 12px;
	}
	::v-deep .el-button--primary {
	   width: 100%;
		max-width: 500px;
		height: 40px;
		border-radius: 6px 6px 6px 6px;
		font-size: 16px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #ffffff;
	}
}
.btn_000{
	::v-deep .el-button--primary {
		background: linear-gradient(137deg, #000 0%, #000 100%);
		border-color: #000;
	}
}
.btn_EEE{
	::v-deep .el-button--primary {
		background: linear-gradient(137deg, #EEE 0%, #EEE 100%);
		border-color: #EEE;
	}
}
</style>
